import styles from "../products/analytics-table.module.css"

export default function CohortRetention({ data }) {
  if (!data || !data.cohorts || data.cohorts.length === 0) {
    return (
      <div className={styles.tableContainer}>
        <h2>Cohort Retention Analysis</h2>
        <p style={{ color: "rgba(255, 255, 255, 0.6)" }}>No cohort data available</p>
      </div>
    )
  }

  return (
    <div className={styles.tableContainer}>
      <h2>Cohort Retention Analysis</h2>
      <p style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px", marginBottom: "20px" }}>
        Cohort Type: {data.cohortType || "monthly"}
      </p>

      {data.cohorts.map((cohort, index) => (
        <div key={index} className={styles.cohortSection}>
          <h3>
            {cohort.cohort} Cohort (Size: {cohort.cohortSize})
          </h3>
          <div className={styles.retentionBars}>
            {cohort.retentionData.map((period, idx) => (
              <div key={idx} className={styles.retentionBar}>
                <div className={styles.barLabel}>Period {period.period}</div>
                <div className={styles.barContainer}>
                  <div className={styles.barFill} style={{ width: `${period.retentionRate}%` }} />
                  <span className={styles.percentage}>{period.retentionRate.toFixed(1)}%</span>
                </div>
                <span style={{ color: "rgba(255, 255, 255, 0.6)", fontSize: "12px", minWidth: "80px" }}>
                  {period.activeUsers} users
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}

      {data.overallRetention && (
        <div className={styles.cohortSection} style={{ marginTop: "25px" }}>
          <h3>Overall Retention Rates</h3>
          <div className={styles.retentionBars}>
            {Object.entries(data.overallRetention).map(([key, value], idx) => (
              <div key={idx} className={styles.retentionBar}>
                <div className={styles.barLabel}>{key.replace("period", "Month ")}</div>
                <div className={styles.barContainer}>
                  <div className={styles.barFill} style={{ width: `${value}%` }} />
                  <span className={styles.percentage}>{value.toFixed(1)}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
